import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import LockIcon from '@material-ui/icons/Lock';
import InputAdornment from '@material-ui/core/InputAdornment';

function PasswordField({ input, meta, label }) {
  return (
    <TextField
      error={meta.submitFailed && meta.error != null}
      helperText={meta.submitFailed && meta.error ? meta.error : ''}
      label={label}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <LockIcon />
          </InputAdornment>
        ),
      }}
      type="password"
      margin="normal"
      fullWidth
      {...input}
    />
  );
}

PasswordField.propTypes = {
  input: PropTypes.shape().isRequired,
  meta: PropTypes.shape().isRequired,
  label: PropTypes.string,
};

PasswordField.defaultProps = {
  label: 'Indtast et kodeord',
};

export default PasswordField;
